<template>
  <div id="app">
    <router-view :key="key"/>
  </div>
</template>

<script>
export default {
  data() {
    return{
    }
  },
  methods: {
    
  },
  computed: {
    key() {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Data()
    }
  },
  created: function() {
  },
  mounted: function() {
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
.L{float: left;}
.R{float: right}
#app {
  font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height:100%
}
html,body{
  height:100%
}
</style>



// WEBPACK FOOTER //
// src/App.vue